import styled from 'styled-components';
import { FONTS, COLORS } from 'pagoefectivo/ui'
import * as imageMobile from '@app/src/assets/img/error-mobile.png';
import * as imageDesktop from '@app/src/assets/img/error-desktop.png';
import * as imageDesktopFull from '@app/src/assets/img/error-desktop-full.png';

export const Wrapper = styled.div`
  width: 100%;
  padding: 60px 32px 0 32px;;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

export const Title = styled.h1`
  font-family: ${FONTS.MULI_BOLD};
  font-size: 48px;
  line-height: 60px;
  text-align: center;

  @media(min-width: 480px) {
    font-size: 72px;
    line-height: 90px;
  }
`;

export const Information = styled.p`
  margin-top: 10px;
  font-family: ${FONTS.MULI_REGULAR};
  font-size: 16px;
  line-height: 24px;
  max-width: 100%;
  width: 556px;
  text-align: center;

  @media(min-width: 480px) {
    font-size: 24px;
    line-height: 32px;
  }
`;

export const Button = styled.button`
  background-color: ${COLORS.YELLOW};
  font-family: ${FONTS.MULI_BOLD};
  font-size: 14px;
  width: 230px;
  height: 40px;
  border: none;
  border-radius: 20px;
  margin-top: 36px;
  cursor: pointer;
`;

export const Image = styled.img`
  display: block;
  margin: 100px auto 0 auto;
  max-width: 100%;
  content: url(${imageMobile});

  @media(min-width: 480px) {
    content: url(${imageDesktop});
  }

  @media(min-width: 780px) {
    content: url(${imageDesktopFull});
  }
`;
